import styled from 'styles/styled';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 10px;
  width: 100%;

  @media (max-width: 720px) {
    padding: 6px 6px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tab = styled.button`
  background: transparent;
  border: 0;
  color: #7A7E8C;
  font-size: 11px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  transition: background 120ms ease, color 120ms ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    color: #EFEFEF;
  }

  &.on {
    color: #EFEFEF;
    background: #292B2E;
    font-weight: 600;
  }

  @media (max-width: 720px) {
    padding: 5px 7px;
    font-size: 10px;
  }
`;

export const Spacer = styled.span`
  flex: 1;
  min-width: 8px;
`;
